import * as LabelPrimitive from "@radix-ui/react-label";
import { forwardRef, type ComponentPropsWithoutRef, type ComponentRef } from "react";
import { cn } from "@/lib/utils";

export interface LabelProps extends ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  /**
   * Agrega el asterisco de "obligatorio". Es solo visual (`aria-hidden`): la
   * obligatoriedad real la declara el control con `required`/`aria-required`,
   * asi el lector de pantalla no lee "asterisco" y la label sigue matcheando
   * por su texto.
   */
  requerido?: boolean;
}

export const Label = forwardRef<ComponentRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, requerido = false, children, ...props }, ref) => (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        /*
         * `block` EXPLICITO. Una `<label>` es `display:inline` por default, y
         * el preflight de Tailwind no la toca. Parecia un bloque de casualidad,
         * porque casi todos los controles del sistema son block-level y se
         * empujan solos al renglon de abajo. Contra un control `inline-flex`
         * —un `Segmented`, por ejemplo— la label se le sentaba al lado y ese
         * campo quedaba con la etiqueta a la izquierda mientras todos los demas
         * la tenian arriba.
         */
        "block text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className,
      )}
      {...props}
    >
      {children}
      {requerido ? (
        <span className="ml-1 text-destructive" aria-hidden="true">
          *
        </span>
      ) : null}
    </LabelPrimitive.Root>
  ),
);
Label.displayName = LabelPrimitive.Root.displayName;
